export const contactFormulierEN = {
  "ContactFormulier.VoorMijzelfIkBenKlant": "For myself. I am a customer of CAK.",
  "ContactFormulier.VoorIemandAndersDieKlantIs": "For someone else who is a customer of CAK.",
  "ContactFormulier.VoorMijzelfIkBenGeenKlant": "For myself. I am not a customer of CAK."
};
